
import * as React from "react";
import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel } from '../uicomponent';
import { CheckboxWithTextCSSStyleImpl } from './checkboxwithtextcss';
import { CheckboxWithTextProps, CheckboxWithTextState, CheckboxWithTextHandler } from './checkboxwithtextcomponent';
import './checkbox-withtext-style.css';

export class CheckboxWithTextView extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onClick = this.onClick.bind(this);
    }

    draw(uiProps: CheckboxWithTextProps, uiState: CheckboxWithTextState, cssStyle: CheckboxWithTextCSSStyleImpl): JSX.Element | boolean
    {
        super.draw(uiProps, uiState, cssStyle);

            if(uiState.isChecked)
            {
                return(
                    <>
                    <div id="checkbox-withtext-style" style={cssStyle.getCSSStyleOne()} onClick={this.onClick}>
                        <div style={cssStyle.getCSSStyleTwo()}/>
                    </div>
                    <label style={cssStyle.getUnSelectedTextCSSStyle()}>{uiProps.title}</label>
                    </>
                ); 
            }
            return <><div id="checkbox-withtext-style" style={cssStyle.getCSSStyleThree()} onClick={this.onClick}/><label style={cssStyle.getSelectedTextCSSStyle()}>{uiProps.title}</label></>;
    }

    onClick(): void 
    {
        (this.getUIComponentHandler() as CheckboxWithTextHandler).onClick();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/checkboxwithtext/checkboxwithtextview.tsx